import bandwidthMeasurementDeadLoad from '../assets/video_bandwidth_512kb.jpg';

export class VideoControllerIOS {
  private path: string = '';
  private jsessionId: string | null;
  private video: HTMLVideoElement;

  private isPlayerStarted = false;
  private currentChannel = 1;
  private isAutoChannel = true;
  private clientBandwidth = 0;
  private bandwidthDownloadSize = [400, 200, 80, 40];
  private bandWidthImageUrl: string = bandwidthMeasurementDeadLoad;
  private latency = 0;
  private channelUpTimer: number | null = null;
  private lowLatencyCounter = 0;
  private isChannelChanging = false;
  private lowLatencyCounterIncreaseTime = this.getCurrentTimeStamp();
  private latencyCheckTimer: number | null = null;
  private videoStoppedDuration = 0;
  private isVideoPausedinGame = false;
  // private latencyUpdatedTime = this.getCurrentTimeStamp();
  private isVideoSuspend = false;
  // private isVideoBufferning = false;
  private latencyListeners: Array<(latency: number) => void> = [];
  private latencyIntervalRef: number | null = null;

  public constructor(jsessionId: string | null) {
    this.video = document.getElementById('video') as HTMLVideoElement;
    this.video.controls = false;
    this.video.muted = true;
    this.video.hidden = false;
    this.jsessionId = jsessionId;

    /**
     * Close and open socket connections on switching tabs/minimizing the browser.
     * This is to avoid the video playing in the background or not starting when the user comes back to the tab.
     */
    window.addEventListener('focus', () => {
      this.connectSocket();
    });
    window.addEventListener('blur', () => {
      this.closeSocket();
    });

    this.calculateClientBandwidth();
  }

  public connectSocket(): void {
    if (this.isVideoPausedinGame) {
      this.isVideoPausedinGame = false;
      this.isChannelChanging = false;

      this.initPlayer();
    }
  }

  public closeSocket(): void {
    if (!this.isVideoPausedinGame) {
      this.isVideoPausedinGame = true;

      setTimeout(() => {
        if (this.isVideoPausedinGame) {
          this.video.pause();
          this.video.src = '';
        }
      }, 2000);

      this.video.pause();
      this.video.src = '';
      // this.video.style.display = 'none';

      this.channelUpTimer && window.clearInterval(this.channelUpTimer);
      this.latencyCheckTimer && window.clearInterval(this.latencyCheckTimer);
    }
  }

  public ngAfterViewInit(path: string = ''): void {
    if (path) {
      this.path = path;
    }

    this.addVideoEventListeners();
    this.updateAndNotifyLatency();
  }

  public onVolumeChange(volume: number): void {
    this.video.volume = volume;
    this.video.muted = volume <= 0;
  }

  public onChannelChanged(data: number | 'auto'): void {
    ////console.log('Channel is manually changed to: ' + data + ", at:" + this.getCurrTime());
    // send event to stats service
    this.isAutoChannel = data === 'auto';
    // console.log('isPlayerStarted', this.isPlayerStarted);
    // console.log('isPlayerStarted', data);
    if (this.isPlayerStarted) {
      if (data !== 'auto' && this.currentChannel != data) {
        // console.log('Channel is manually changed to: ' + data + ', at:' + this.getCurrentTimeStamp());
        this.onChannelSelected(parseInt(data as unknown as string));
      }
    } else if (typeof data === 'number') {
      this.currentChannel = data;
    }
  }

  public addLatencyListener(listener: (latency: number) => void): void {
    this.latencyListeners.push(listener);
  }

  public resetPlayer(): void {
    this.video.pause();
  }

  private initPlayer(): void {
    //console.log("============initPlayer", this.isChannelChanging)
    if (this.isChannelChanging) return;

    this.isChannelChanging = false;

    this.onVideoPlay();

    this.channelUpTimer && window.clearInterval(this.channelUpTimer);
    this.channelUpTimer = window.setInterval(
      () => {
        this.checkForChannelUp();
      },
      60 * 1000 * 5
    );

    this.latencyCheckTimer && window.clearInterval(this.latencyCheckTimer);
    this.latencyCheckTimer = window.setInterval(() => {
      this.latencyCheck();
    }, 1000);
  }

  private addVideoEventListeners(): void {
    if (!this.video) return;

    this.video.addEventListener('canplay', () => {
      this.playVideo();
    });

    this.video.addEventListener('suspend', () => {
      if (!this.video || this.isVideoSuspend) return;
      this.isVideoSuspend = true;
    });

    this.video.addEventListener('stalled', () => {
      if (!this.video) return;

      //console.log("reloaded video on stalled error event",ref.isChannelChanging);
      if (this.isChannelChanging && !this.isVideoPlaying()) {
        this.video.pause();
        this.video.load();
        this.videoStoppedDuration = 0;
        this.isChannelChanging = false;
        this.reloadVideo();
      }
    });

    this.video.addEventListener('playing', () => {
      //console.log("video started playing");
      // The index should be at least 0 and less than the playlist length. Gives exception "The index is not in the allowed range."
      if (!this.video.buffered.length) return;

      this.latency = this.video.buffered.end(0) - this.video.currentTime;
      if (!this.isPlayerStarted) {
        this.isPlayerStarted = true;
      }
      // this.isVideoBufferning = false;
    });

    this.video.addEventListener('waiting', () => {
      if (this.isVideoPausedinGame) return;

      //console.log('Video in waiting and readystate ', ref.video.readyState, '  lowlatencyCounter ', ref.lowLatencyCounter);
      if (this.video.readyState == 2 || this.video.readyState == 1) {
        ////console.log('Video is waiting................');
        this.lowLatencyCounter++;
        this.lowLatencyCounterIncreaseTime = this.getCurrentTimeStamp();
      }
      //if (!ref.isvideoBufferning) {
      this.latency = this.video.buffered.end(0) - this.video.currentTime;
      // this.isVideoBufferning = true;
      //}
      if (this.lowLatencyCounter >= 6) {
        const channel = this.getChannel('down');
        //console.log('downgrading...',channel,ref.currentChannel,ref.lowLatencyCounter);

        if (this.currentChannel != channel && channel != -1) {
          this.isChannelChanging = false;

          if (!this.isAutoChannel) {
            ////console.log('Here throw a pop-up that not sufficient bandwidth....and switching to Auto');
            this.isAutoChannel = true;
          }
          ////console.log('changing channel down ', channel);
          this.currentChannel = channel;
          this.ShiftChannel();
          this.lowLatencyCounter = 0;
          this.lowLatencyCounterIncreaseTime = this.getCurrentTimeStamp();
        } else if (channel == -1 && this.isPlayerStarted) {
          this.video.pause();
          this.video.src = '';
          this.video.load();
          // this.latencyUpdatedTime = this.getCurrentTimeStamp();
          ////console.log('Here throw an error that not enough bandwidth...Give button to restart video');
        }
      }
    });
  }

  private updateAndNotifyLatency(): void {
    if (this.latencyIntervalRef) {
      clearInterval(this.latencyIntervalRef);
      this.latencyIntervalRef = null;
    }
    this.latencyIntervalRef = window.setInterval(() => {
      if (this.video.buffered.length > 0 && this.isVideoPlaying() === true) {
        this.latency = this.video.buffered?.end(0) - this.video.currentTime;
        this.latencyListeners.forEach((listener) => listener(parseFloat((this.latency * 1000).toFixed(2))));
      }
    }, 3000);
  }

  private checkForChannelUp(): void {
    //console.log("checkForChannelUp: ", (new Date), this.lowLatencyCounter, this.isChannelChanging, this.currentChannel);
    if (this.isAutoChannel) {
      //console.log('checking for up b/w', this.currentChannel);
      if (this.currentChannel != 0 && this.lowLatencyCounter == 0 && !this.isChannelChanging) {
        this.calculateClientBandwidth();
      }
    }
  }

  private latencyCheck(): void {
    //console.log("latencyCheck")
    if (this.video.buffered.length > 0) {
      this.latency = this.video.buffered.end(0) - this.video.currentTime;
      //console.log('Latency ' , this.latency.toFixed(2) , ' Total Video Time ', parseFloat(this.video.buffered.end(0)).toFixed(2) , ' Video Current Time ' , parseFloat(this.video.currentTime).toFixed(2) , ' Video Duration ' , this.video.duration , ' Playbackrate ' , this.video.playbackRate , ' lowLatencyCounter ' , this.lowLatencyCounter, ' currentChannel ', this.currentChannel,"Auto ", this.isAutoChannel,"readyState: ",this.video.readyState,this.video.src,this.isChannelChanging);
      if (this.latency > 2.5 && this.latency <= 4) {
        this.video.playbackRate = 2;
      } else if (this.latency > 4 && this.isPlayerStarted && !this.isChannelChanging && this.video.currentTime > 60) {
        //console.log(latency ," ---- downgraded...",this.currentChannel);
        if (this.currentChannel < 3) {
          this.currentChannel = this.currentChannel + 1;
        }
        this.reloadVideo();
      } else {
        this.video.playbackRate = 1;
      }
    }
    if (this.getCurrentTimeStamp() - this.lowLatencyCounterIncreaseTime > 2 * 60 * 1000) {
      this.lowLatencyCounter = 0;
    }

    if (!this.isVideoPlaying()) {
      this.videoStoppedDuration++;
      if (this.videoStoppedDuration >= 20) {
        //console.log(this.videoStoppedDuration,"video Stoped for more than 20sec... video is reloaded here")
        this.videoStoppedDuration = 0;
        this.isChannelChanging = false;
        this.reloadVideo();
        // if (!this.isPlayerStarted && this.videoVolume > 0) {
        //   this.video.volume = this.videoVolume;
        //   this.video.muted = false;
        // }
      }
    } else {
      this.videoStoppedDuration = 0;
    }
  }

  private playVideo(): void {
    const playPromise = this.video.play();
    if (playPromise !== undefined && document.hasFocus()) {
      playPromise
        .then(() => {
          this.video.play();
        })
        .catch((error) => {
          //console.log(playPromise,"error");
        });
    } else {
      //console.log(playPromise,"unable to play video");
    }
  }

  private onVideoPlay(): void {
    try {
      //console.log(this.isPlayerStarted,this.isChannelChanging," onVideoPlay",this.isVideoPausedinGame );
      // if (this.isChannelChanging || this.isVideoOffOnBlur)
      if (this.isChannelChanging) return;

      // this.latencyUpdatedTime = this.getCurrentTimeStamp();
      // this.video.crossOrigin = 'anonymous';
      this.video.src = this.getChannelVideoURL();
      this.video.load();
      this.isChannelChanging = true;
      this.videoStoppedDuration = 0;
      this.lowLatencyCounterIncreaseTime = this.getCurrentTimeStamp();

      this.video.oncanplay = (): void => {
        if (this.isChannelChanging) {
          console.log(' loaded video.... ', this.currentChannel);
          this.playVideo();
          this.latency = this.video.buffered.length ? this.video.buffered.end(0) - this.video.currentTime : 0;
          this.isVideoSuspend = false;
          this.isChannelChanging = false;
        }
      };

      this.channelUpTimer && window.clearInterval(this.channelUpTimer);
      this.channelUpTimer = window.setInterval(
        () => {
          this.checkForChannelUp();
        },
        60 * 1000 * 5
      );
    } catch (err) {
      console.log(err, 'error');
    }
  }

  private isVideoPlaying(): boolean {
    return this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2;
  }

  private calculateClientBandwidth(): void {
    ////console.log("Started Bandwidth New Calculation...",+new Date())
    const imageUrl = this.bandWidthImageUrl + '?n=' + Math.random();
    const downloadSize = 0.5 * 1024 * 1024;

    const xhr = new XMLHttpRequest();
    xhr.open('GET', imageUrl, true);
    xhr.responseType = 'arraybuffer';
    xhr.timeout = 10000;

    xhr.ontimeout = (): void => {
      if (!this.isPlayerStarted) {
        this.currentChannel = 3;
        //console.log("client bandwidth detection took morethan 10 secs  loaded low quality");
        this.initPlayer();
      }
    };

    xhr.onprogress = (): void => {
      //console.log(ev.loaded , ev.total)
    };

    const startTime: number = this.getCurrentTimeStamp();
    let endTime: number;
    xhr.onloadend = (): void => {
      ////console.log(xhr.status)
      if (xhr.status == 200) {
        if (this.isPlayerStarted) return;
        endTime = this.getCurrentTimeStamp();
        const duration = (endTime - startTime) / 1000;
        const speedBps = Math.round(downloadSize / duration);
        // ////console.log("Your connection speed is: " + speedBps.toFixed(2) + " bps "   + 	speedKbps.toFixed(2) + " kbps " +  + 	speedMbps + " Mbps ",duration,endTime,startTime);
        this.clientBandwidth = speedBps / 1024;
        const channel = this.getChannel('up');
        //console.log("clientBandwidth====================== ", ref.clientBandwidth + " kbps ",channel);
        if (channel != -1) {
          this.currentChannel = channel;
          //console.log("clientBandwidth====================== ", ref.clientBandwidth + " kbps ",channel);
          this.initPlayer();
        } else {
          ////console.log("Show a pop-up that not enough b/w.....Reinit player ....");
        }
      } else {
        //console.log("Image download error in status check on client bandwidth detection by default playing low quality channel2")
        if (!this.isPlayerStarted) {
          this.currentChannel = 2;
          this.initPlayer();
        }
      }
    };

    xhr.onerror = (): void => {
      ////console.log("Image download error on client bandwidth detection by default playing low quality channel2")
      //console.log("Image download error on client bandwidth detection by default playing low quality channel2")
      if (!this.isPlayerStarted) {
        this.currentChannel = 2;
        this.initPlayer();
      }
    };

    xhr.send();
  }

  private getCurrentTimeStamp(): number {
    return Date.now();
  }

  private getChannel(direction: 'up' | 'down'): number {
    if (direction == 'up') {
      //curCh--;
      const bandWdth = this.clientBandwidth;
      if (bandWdth > this.bandwidthDownloadSize[0]) {
        return 0;
      } else if (bandWdth > this.bandwidthDownloadSize[1]) {
        return 1;
      } else if (bandWdth > this.bandwidthDownloadSize[2]) {
        return 2;
      } else if (bandWdth > this.bandwidthDownloadSize[3]) {
        return 3;
      }
      return -1;
    } else {
      if (this.currentChannel == 0) {
        return 1;
      } else if (this.currentChannel == 1) {
        return 2;
      } else if (this.currentChannel == 2) {
        return 3;
      }
      return -1;
    }
  }

  private onChannelSelected(channel: number): void {
    // console.log('Channel is manually changed to: ' + channel + ', at:' + this.getCurrentTimeStamp());
    this.currentChannel = channel;
    this.ShiftChannel();
  }

  private ShiftChannel(): void {
    //console.log(this.isChannelChanging," ShiftChannel")
    if (!this.isChannelChanging) {
      this.video.pause();
      this.onVideoPlay();
    }
  }

  private reloadVideo(): void {
    this.onVideoPlay();
  }

  private getChannelVideoURL(): string {
    if (this.currentChannel == 0) {
      return this.path + '/quality0/vodmain.m3u8?' + this.jsessionId;
    } else if (this.currentChannel == 1) {
      return this.path + '/quality1/vodmain.m3u8?' + this.jsessionId;
    } else if (this.currentChannel == 2) {
      return this.path + '/quality2/vodmain.m3u8?' + this.jsessionId;
    } else {
      return this.path + '/quality3/vodmain.m3u8?' + this.jsessionId;
    }
  }

  getChannelLimit(): number {
    return this.isAutoChannel ? this.currentChannel : this.getChannel('up');
  }
}
